export default function PC(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="1.44229" y="3.78555" width="29.1158" height="20.326" rx="0.998279" stroke="#757575" strokeWidth="1.2" />
            <path d="M1.22803 20.4717H30.7726" stroke="#757575" strokeWidth="1.2" />
            <path d="M15.3051 22.2402L16.695 22.2402" stroke="#757575" strokeWidth="1.2" strokeLinecap="round" />
            <path d="M12.9259 24.7119L12.5654 26.7653" stroke="#757575" strokeWidth="1.2" strokeLinecap="square" />
            <path d="M19.075 24.7119L19.4355 26.7653" stroke="#757575" strokeWidth="1.2" strokeLinecap="square" />
            <mask id="path-6-inside-1_570_18944" fill="white">
                <rect x="9.47363" y="26.7646" width="12.779" height="2.05014" rx="0.799139" />
            </mask>
            <rect
                x="9.47363"
                y="26.7646"
                width="12.779"
                height="2.05014"
                rx="0.799139"
                stroke="#757575"
                strokeWidth="1.8"
                mask="url(#path-6-inside-1_570_18944)"
            />
        </svg>
    );
}
